import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Alert, Dialog, DialogContent, DialogTitle, ListSkeleton, Stack, useToast, } from '@platform/design-system';
import { useSession } from "../auth/session.js";
import { describeError } from "../http/errors.js";
import { CodeStep } from "./auth-steps.js";
import { TotpSetupPanel } from "./totp-setup-panel.js";
/**
 * Account settings: enrol an authenticator while signed in (`AssociateSoftwareToken` →
 * `VerifySoftwareToken` → TOTP preferred). Opens straight into the QR; answers with a toast.
 * The body mounts fresh on every open, so each attempt starts from a clean state.
 */
export function TotpSettingsDialog({ open, onClose }) {
    const [busy, setBusy] = useState(false);
    const titleId = 'totp-settings-title';
    return (_jsxs(Dialog, { open: open, onClose: busy ? undefined : onClose, maxWidth: "xs", fullWidth: true, "aria-labelledby": titleId, children: [_jsx(DialogTitle, { id: titleId, children: "Two-step verification" }), _jsx(DialogContent, { children: open && _jsx(TotpSettingsBody, { busy: busy, setBusy: setBusy, onClose: onClose }) })] }));
}
function TotpSettingsBody({ busy, setBusy, onClose, }) {
    const session = useSession();
    const toast = useToast();
    const [setup, setSetup] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        let cancelled = false;
        session
            .beginTotpSetup()
            .then((s) => {
            if (!cancelled)
                setSetup(s);
        })
            .catch((e) => {
            if (!cancelled)
                setError(describeError(e, 'Could not start the setup. Try again.'));
        });
        return () => {
            cancelled = true;
        };
    }, [session]);
    return (_jsxs(Stack, { spacing: 2.5, sx: { pt: 1 }, children: [error && _jsx(Alert, { severity: "error", children: error }), !setup && !error && _jsx(ListSkeleton, { rows: 4 }), setup && (_jsxs(_Fragment, { children: [_jsx(TotpSetupPanel, { secret: setup.secret, uri: setup.uri }), _jsx(CodeStep, { busy: busy, label: "Code from the app", submitLabel: "Turn on", onSubmit: ({ code }) => {
                            setBusy(true);
                            setError(null);
                            session
                                .confirmTotpSetup(code)
                                .then(() => {
                                toast.success('Two-step verification is on');
                                onClose();
                            })
                                .catch((e) => setError(describeError(e, 'That did not work. Try again.')))
                                .finally(() => setBusy(false));
                        } })] }))] }));
}
//# sourceMappingURL=totp-settings-dialog.js.map